export default {
    plugins: ["print",
        "code",
        "preview",
        "searchreplace",
        "autolink",
        "directionality",
        "fullscreen",
        "image",
        "link",
        "media",
        "table",
        "charmap",
        "hr",
        "pagebreak",
        "toc",
        "insertdatetime",
        "advlist",
        "lists",
        "textcolor",
        "wordcount",
        "contextmenu",
        "colorpicker",
        "textpattern",
        "help"],
    toolbar: "code | formatselect | bold italic strikethrough forecolor backcolor | image | alignleft aligncenter" +
    "alignright alignjustify  | numlist bullist outdent indent  | removeformat"
};



// WEBPACK FOOTER //
// ./node_modules/eslint-loader!./src/components/author/plugins.ts